import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useAppLinks() {
  const [links, setLinks] = useState({ app_store_url: "", play_store_url: "" });
  useEffect(() => {
    api.get("/public/app-links").then(setLinks).catch(() => {});
  }, []);
  return links;
}

const AppleIcon = () => (
  <svg viewBox="0 0 384 512" className="h-6 w-6 flex-shrink-0 fill-current" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 512 512" className="h-6 w-6 flex-shrink-0" aria-hidden="true">
    <path fill="#4285F4" d="M48 32 L272 256 L48 480 C38 472 32 460 32 446 V66 C32 52 38 40 48 32Z" />
    <path fill="#34A853" d="M48 32 C58 25 72 24 86 32 L362 190 L272 256Z" />
    <path fill="#EA4335" d="M48 480 C58 487 72 488 86 480 L362 322 L272 256Z" />
    <path fill="#FBBC04" d="M362 190 L448 239 C462 247 462 265 448 273 L362 322 L272 256Z" />
  </svg>
);

function StoreButton({ href, icon: Icon, small, big, testid, fluid }) {
  const base = `inline-flex items-center gap-3 h-14 ${fluid ? "w-full justify-center" : "w-[200px] pl-5 pr-4"} rounded-2xl transition-[transform,background-color] duration-200`;
  if (!href) {
    return (
      <span data-testid={testid} aria-disabled="true"
        className={`${base} bg-slate-200 text-slate-500 cursor-not-allowed`}>
        <Icon />
        <span className="text-left leading-tight">
          <span className="block text-[10px] font-semibold uppercase tracking-wider">Coming soon</span>
          <span className="block text-base font-bold">{big}</span>
        </span>
      </span>
    );
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid}
      className={`${base} bg-slate-900 text-white hover:bg-black hover:-translate-y-0.5`}>
      <Icon />
      <span className="text-left leading-tight">
        <span className="block text-[10px] font-medium opacity-80">{small}</span>
        <span className="block text-base font-bold">{big}</span>
      </span>
    </a>
  );
}

export function StoreButtons({ links, prefix, fluid = false }) {
  return (
    <div className={fluid ? "grid grid-cols-2 gap-3" : "flex flex-wrap gap-3"} data-testid={`${prefix}-store-buttons`}>
      <StoreButton href={links.app_store_url} icon={AppleIcon} small="Download on the" big="App Store" testid={`${prefix}-app-store-btn`} fluid={fluid} />
      <StoreButton href={links.play_store_url} icon={PlayIcon} small="Get it on" big="Google Play" testid={`${prefix}-play-store-btn`} fluid={fluid} />
    </div>
  );
}
